import { createFormItem } from "@/component-create/utils/create-form-item"
import { FormDialog } from "@/component-create/FormDialog"
import { FORM_ITEM } from "@/components/form/enums"

import { MAIL_ADDRESS } from "@/utils/pattern"
import { MAIL_CONTACT_BASE_URL } from "@/api/system/mail-recipient"

/**
 * 绘制新增表单
 */
 export function renderContactAddForm(el: Element) {
  const addForm = new FormDialog(
    el, 
    { 
      items: items, 
      elFormProps: { rules: rules, labelWidth: '100px' }, 
      saveUrl: MAIL_CONTACT_BASE_URL 
    },
    '新增'
  )

  return addForm
}

const items = [
  [
    createFormItem('联系人名称', 'recipientName', FORM_ITEM.INPUT, { clearable: true, maxlength: '20' })
  ],
  [
    createFormItem('邮箱地址', 'mailAddress', FORM_ITEM.INPUT, { clearable: true, maxlength: '64' })
  ],
  [
    createFormItem('备注', 'remark', FORM_ITEM.INPUT, { type: 'textarea', rows: 3, maxlength: '200' }),
  ]
]

const rules = {
  recipientName: [{ required: true, message: '请输入联系人名称', trigger: 'blur' }],
  mailAddress: [{ required: true, message: '请输入邮箱地址', trigger: 'blur' },
    { pattern: MAIL_ADDRESS, message: '请输入正确的邮箱地址', trigger: 'blur' }]
}